import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import { getLoaderStatus } from '../loader/loaderSelector';


const ImageWithSkeleton = ({
    src,
    alt,
    className = '',
    skeletonClassName = '',
    onLoad: onLoadProp,
    style,
    skeletonSx,
    fetchPriority
}) => {
    const isLoading = useSelector(getLoaderStatus);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    const handleLoad = useCallback(() => {
        setLoaded(true);
        if (onLoadProp) onLoadProp();
    }, [onLoadProp]);

    const handleError = useCallback(() => {
        setError(true);
    }, []);

    const showSkeleton = isLoading || (!loaded && !error);

    return (
        <span
            className="image-with-skeleton-wrapper"
            style={{
                position: 'relative',
                display: 'block',
                width: '100%'
            }}
        >
            {showSkeleton && (
                <Skeleton
                    animation="wave"
                    variant="rectangular"
                    className={skeletonClassName || 'skeletonclass'}
                    sx={{
                        width: '100%',
                        height: 'auto',
                        ...skeletonSx
                    }}
                />
            )}
            <img
                className={className}
                alt={alt}
                src={src}
                onLoad={handleLoad}
                onError={handleError}
                loading='lazy'
                decoding="async"
                {...(fetchPriority ? { fetchpriority: fetchPriority } : {})}
                style={showSkeleton
                    ? {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        opacity: 0,
                        pointerEvents: 'none'
                    }
                    : style}
            />
        </span>
    );
};

ImageWithSkeleton.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
    skeletonClassName: PropTypes.string,
    onLoad: PropTypes.func,
    style: PropTypes.object,
    skeletonSx: PropTypes.object,
    fetchPriority: PropTypes.oneOf(['high', 'low', 'auto'])
};

ImageWithSkeleton.defaultProps = {
    className: '',
    skeletonClassName: '',
    onLoad: undefined,
    style: undefined,
    skeletonSx: undefined,
    fetchPriority: undefined
};

export default ImageWithSkeleton;
